import type { Translations } from '../types';

/** Deutsch */
export const de: Translations = {
  'app.name': 'ITA6',
  'app.tagline': 'Online-Wettbewerbe auf Basis von Können',
  'app.skipToContent': 'Zum Hauptinhalt springen',

  'nav.primary': 'Hauptnavigation',
  'nav.openMenu': 'Menü öffnen',
  'nav.closeMenu': 'Menü schließen',
  'nav.home': 'Startseite',
  'nav.dashboard': 'Übersicht',
  'nav.profile': 'Profil',
  'nav.admin': 'Verwaltung',
  'nav.signIn': 'Anmelden',
  'nav.signOut': 'Abmelden',
  'nav.createAccount': 'Konto erstellen',

  'role.user': 'Teilnehmer',
  'role.admin': 'Administrator',
  'role.userShort': 'Teilnehmer',
  'role.adminShort': 'Administrator',

  'status.active': 'aktiv',
  'status.suspended': 'gesperrt',
  'status.deleted': 'gelöscht',
  'status.verified': 'bestätigt',
  'status.notVerified': 'nicht bestätigt',

  'common.loading': 'Wird geladen…',
  'common.refresh': 'Aktualisieren',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.backToHome': 'Zurück zur Startseite',
  'common.backToDashboard': 'Zurück zur Übersicht',
  'common.backToContest': 'Zurück zum Wettbewerb',
  'common.notAvailable': 'Nicht verfügbar',

  'theme.label': 'Erscheinungsbild',
  'theme.light': 'Hell',
  'theme.dark': 'Dunkel',
  'theme.system': 'System',

  'language.label': 'Sprache',

  'home.hero.title': 'Beweise dein Können.',
  'home.hero.titleAccent': 'Gewinne durch Leistung.',
  'home.hero.subtitle':
    'ITA6 ist eine Wettbewerbsplattform auf Basis von Können. Nimm an talentbasierten Wettbewerben teil, löse zeitlich begrenzte objektive Aufgaben und überlasse die Entscheidung veröffentlichten Bewertungsregeln — nicht dem Zufall.',
  'home.hero.goToDashboard': 'Zur Übersicht',
  'home.hero.createAccount': 'Konto erstellen',
  'home.hero.signIn': 'Anmelden',
  'home.highlights.title': 'Was ITA6 bietet',
  'home.highlights.contests': 'Wettbewerbe ansehen und die Zahl der Teilnehmenden erkennen',
  'home.highlights.prizes': 'Transparente Preistöpfe, finanziert aus Startgebühren',
  'home.highlights.timed': 'Zeitlich begrenzte objektive Aufgaben mit fairer Bewertung',
  'home.highlights.results': 'Ranglisten mit Gleichstandsbehandlung und veröffentlichten Ergebnissen',
  'home.highlights.admin': 'Rollenbasierte Verwaltung von Wettbewerben, Nutzern und Auszahlungen',
  'home.highlights.note':
    'Die Anmeldung öffnet in Kürze. Erstelle jetzt dein Konto und sei am ersten Tag dabei.',
  'home.features.title': 'Auf Fairness ausgelegt',
  'home.features.subtitle':
    'Jede Designentscheidung dient einem Ziel: Die teilnehmende Person mit dem größten Können soll gewinnen.',
  'home.features.skill.title': 'Können statt Zufall',
  'home.features.skill.body':
    'Wettbewerbe werden durch objektive Leistung entschieden. Gewinner ergeben sich aus veröffentlichten Bewertungsregeln — nie aus einer Ziehung.',
  'home.features.scoring.title': 'Objektive Bewertung',
  'home.features.scoring.body':
    'Antworten werden von der Plattform selbst bewertet und zeitlich erfasst. Eine Punktzahl lässt sich nicht aus dem Browser ändern.',
  'home.features.standing.title': 'Transparente Ranglisten',
  'home.features.standing.body':
    'Teilnehmerzahl, Preistöpfe und Ranglisten sind für alle Teilnehmenden sichtbar — vor und nach dem Ergebnis.',
  'home.features.accounts.title': 'Ein Konto für alle Wettbewerbe',
  'home.features.accounts.body':
    'Ein bestätigtes Profil erfasst deine Teilnahmen, Ergebnisse und Gewinne auf der gesamten Plattform.',
  'home.steps.title': 'So läuft ein Wettbewerb ab',
  'home.steps.one.title': 'Profil anlegen',
  'home.steps.one.body': 'Einmal registrieren und für alle Wettbewerbe bereit sein.',
  'home.steps.two.title': 'An einem Wettbewerb teilnehmen',
  'home.steps.two.body':
    'Zahle die Startgebühr für einen Wettbewerb, der zu deinen Interessen passt.',
  'home.steps.three.title': 'Die Aufgabe lösen',
  'home.steps.three.body':
    'Beantworte zeitlich begrenzte objektive Fragen mit fairer, von der Plattform gesetzter Zeit.',
  'home.steps.four.title': 'Deine Platzierung sehen',
  'home.steps.four.body':
    'Erziele eine objektive Punktzahl und steige in einer transparenten Rangliste auf.',
  'home.cta.title': 'Bereit, dein Können zu testen?',
  'home.cta.body': 'Erstelle ein kostenloses Konto und sei bereit, wenn die ersten Wettbewerbe starten.',
  'home.cta.button': 'Loslegen',

  'login.title': 'Willkommen zurück',
  'login.subtitle': 'Melde dich bei deinem ITA6-Konto an.',
  'login.cardTitle': 'Anmelden',
  'login.cardDescription': 'Verwende die E-Mail-Adresse und das Passwort deiner Registrierung.',
  'login.email': 'E-Mail-Adresse',
  'login.emailPlaceholder': 'du@beispiel.de',
  'login.password': 'Passwort',
  'login.passwordPlaceholder': 'Dein Passwort',
  'login.submit': 'Anmelden',
  'login.noAccount': 'Noch kein Konto?',
  'login.createOne': 'Jetzt erstellen',
  'login.errorRequired': 'Gib deine E-Mail-Adresse und dein Passwort ein.',
  'login.errorGeneric': 'Anmeldung fehlgeschlagen. Bitte versuche es erneut.',

  'register.title': 'Konto erstellen',
  'register.subtitle': 'Ein Konto für alle ITA6-Wettbewerbe. Die Teilnahme ist kostenlos.',
  'register.cardTitle': 'Registrierung',
  'register.cardDescription': 'Alle Felder außer dem Anzeigenamen sind erforderlich.',
  'register.displayName': 'Anzeigename (optional)',
  'register.displayNamePlaceholder': 'Der Name in den Ranglisten',
  'register.email': 'E-Mail-Adresse',
  'register.password': 'Passwort',
  'register.passwordPlaceholder': 'Mindestens {min} Zeichen',
  'register.confirmPassword': 'Passwort bestätigen',
  'register.confirmPlaceholder': 'Passwort wiederholen',
  'register.submit': 'Konto erstellen',
  'register.securityNote':
    'Dein Passwort wird mit einem branchenüblichen Hashverfahren sicher gespeichert.',
  'register.haveAccount': 'Du hast bereits ein Konto?',
  'register.signIn': 'Anmelden',
  'register.errorGeneric': 'Registrierung fehlgeschlagen. Bitte versuche es erneut.',

  'validation.emailRequired': 'E-Mail-Adresse ist erforderlich.',
  'validation.emailInvalid': 'Gib eine gültige E-Mail-Adresse ein.',
  'validation.passwordMin': 'Das Passwort muss mindestens {min} Zeichen lang sein.',
  'validation.passwordComplexity':
    'Das Passwort muss mindestens einen Buchstaben und eine Zahl enthalten.',
  'validation.passwordMismatch': 'Die Passwörter stimmen nicht überein.',

  'dashboard.title': 'Willkommen, {name}',
  'dashboard.subtitle':
    'Dies ist deine ITA6-Übersicht. Deine Wettbewerbe und Ergebnisse erscheinen hier.',
  'dashboard.adminConsole': 'Verwaltungskonsole',
  'dashboard.viewProfile': 'Profil ansehen',
  'dashboard.stat.displayName': 'Anzeigename',
  'dashboard.stat.email': 'E-Mail-Adresse',
  'dashboard.stat.role': 'Rolle',
  'dashboard.stat.memberSince': 'Mitglied seit',
  'dashboard.stat.lastLogin': 'Letzte Anmeldung: {date}',
  'dashboard.roleHint.admin': 'Vollständiger Verwaltungszugriff',
  'dashboard.roleHint.user': 'Teilnehmerzugriff',
  'dashboard.contests.title': 'Deine Wettbewerbe',
  'dashboard.contests.description':
    'Wettbewerbe, an denen du teilnimmst, werden hier mit Status und Ergebnissen aufgeführt.',
  'dashboard.contests.empty.title': 'Noch keine Wettbewerbe',
  'dashboard.contests.empty.body':
    'Die Anmeldung öffnet in Kürze. Sobald du an einem Wettbewerb teilnimmst, erscheint er hier.',
  'dashboard.account.title': 'Kontostatus',
  'dashboard.account.description': 'Der aktuelle Stand deines Kontos.',
  'dashboard.account.status': 'Status',
  'dashboard.account.emailVerified': 'E-Mail bestätigt',
  'dashboard.account.role': 'Rolle',
  'dashboard.account.id': 'Konto-ID',

  'profile.title': 'Dein Profil',
  'profile.subtitle':
    'Diese Informationen sehen andere Teilnehmende zusammen mit deinen Ergebnissen.',
  'profile.details.title': 'Profildetails',
  'profile.details.description': 'Öffentliche Angaben, die mit deinen Ergebnissen erscheinen.',
  'profile.field.displayName': 'Anzeigename',
  'profile.field.country': 'Land',
  'profile.field.bio': 'Über mich',
  'profile.account.title': 'Kontodetails',
  'profile.account.description': 'Deine privaten Kontoinformationen.',
  'profile.field.email': 'E-Mail-Adresse',
  'profile.field.emailVerified': 'E-Mail bestätigt',
  'profile.field.role': 'Rolle',
  'profile.field.status': 'Status',
  'profile.field.memberSince': 'Mitglied seit',
  'profile.field.lastLogin': 'Letzte Anmeldung',
  'profile.field.accountId': 'Konto-ID',

  'admin.title': 'Verwaltungskonsole',
  'admin.subtitle': 'Plattformstatus und administrativer Zugang.',
  'admin.refresh': 'Aktualisieren',
  'admin.loading': 'Verwaltungskonsole wird geladen…',
  'admin.errorLoad': 'Plattformstatus konnte nicht geladen werden.',
  'admin.signedInAs': 'Angemeldet als',
  'admin.users': 'Benutzer',
  'admin.usersSummary': '{admins} Administratoren · {active} aktiv',
  'admin.apiLabel': 'Plattform-API',
  'admin.apiHealthy': 'betriebsbereit',
  'admin.apiUnavailable': 'nicht verfügbar',
  'admin.database': 'Datenbank',
  'admin.databaseOk': 'verbunden',
  'admin.databaseUnavailable': 'nicht verfügbar',
  'admin.databaseUnknown': 'unbekannt',
  'admin.serverTime': 'Serverzeit: {date}',
  'admin.session.title': 'Sitzung',
  'admin.session.description': 'Dein authentifizierter Administratorkontext.',
  'admin.field.email': 'E-Mail-Adresse',
  'admin.field.role': 'Rolle',
  'admin.field.accountId': 'Konto-ID',
  'admin.field.statusChecked': 'Status geprüft',
  'admin.roadmap.title': 'Verwaltung',
  'admin.roadmap.description': 'Was du von dieser Konsole aus verwaltest.',
  'admin.roadmap.contests': 'Wettbewerbe und Aufgaben erstellen und konfigurieren',
  'admin.roadmap.questions': 'Fragen verfassen und Lösungen verwalten',
  'admin.roadmap.payments': 'Startgebühren und Teilnehmerlisten prüfen',
  'admin.roadmap.results': 'Ergebnisse, Ranglisten und Gewinnauszahlungen veröffentlichen',
  'admin.roadmap.users': 'Benutzer moderieren und Einstellungen verwalten',

  'guard.checkingSession': 'Sitzung wird geprüft…',
  'guard.accessDenied.title': 'Zugriff verweigert',
  'guard.accessDenied.body':
    'Dieser Bereich ist Administratoren vorbehalten. Wenn du Zugriff haben solltest, wende dich an den Betreiber der Plattform.',

  'notFound.title': 'Seite nicht gefunden',
  'notFound.body': 'Die gesuchte Seite existiert nicht oder wurde verschoben.',

  'api.networkError': 'ITA6 ist nicht erreichbar. Prüfe deine Verbindung und versuche es erneut.',
  'api.requestFailed': 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
  'api.invalidCredentials': 'E-Mail-Adresse oder Passwort ist falsch.',
  'api.emailTaken': 'Mit dieser E-Mail-Adresse existiert bereits ein Konto.',
  'api.accountInactive': 'Dieses Konto ist nicht aktiv.',
  'api.sessionExpired': 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
  'api.unauthorized': 'Bitte melde dich an, um fortzufahren.',
  'api.forbidden': 'Du bist für diese Aktion nicht berechtigt.',
  'api.invalidEmail': 'Gib eine gültige E-Mail-Adresse ein.',
  'api.weakPassword': 'Das Passwort erfüllt die Anforderungen nicht.',
  'api.internalError': 'Auf unserer Seite ist ein Fehler aufgetreten. Bitte versuche es erneut.',

  'footer.copyright': '© {year} ITA6. Alle Rechte vorbehalten.',
  'footer.legal': 'Rechtliches',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.privacy': 'Datenschutz',
  'footer.contact': 'Kontakt',

  // --- Phase 2: die Wettbewerbswelt ----------------------------------------
  'nav.contests': 'Wettbewerbe',
  'nav.myEntries': 'Meine Teilnahmen',
  'nav.adminContests': 'Wettbewerbsverwaltung',
  'nav.adminPayments': 'Zahlungen',

  'common.save': 'Speichern',
  'common.cancel': 'Abbrechen',
  'common.close': 'Schließen',
  'common.confirm': 'Bestätigen',
  'common.actions': 'Aktionen',
  'common.status': 'Status',
  'common.amount': 'Betrag',
  'common.date': 'Datum',
  'common.none': 'Keine',
  'common.submit': 'Absenden',
  'common.details': 'Details',
  'common.optional': 'optional',
  'common.rail': 'Zahlungsweg',
  'common.asset': 'Wert',

  'rail.all': 'Alle Wettbewerbe',
  'rail.fiat': 'Fiat',
  'rail.crypto': 'Krypto',

  'contest.phase.draft': 'Entwurf',
  'contest.phase.scheduled': 'Geplant',
  'contest.phase.registration_open': 'Anmeldung offen',
  'contest.phase.registration_closed': 'Anmeldung geschlossen',
  'contest.phase.live': 'Läuft jetzt',
  'contest.phase.awaiting_results': 'Ergebnisse ausstehend',
  'contest.phase.results_ready': 'Ergebnisse verfügbar',
  'contest.phase.cancelled': 'Abgesagt',
  'contest.phase.voided': 'Ungültig',

  'participant.status.registered': 'Angemeldet',
  'participant.status.awaiting_payment': 'Zahlung ausstehend',
  'participant.status.confirmed': 'Bestätigt',
  'participant.status.active': 'Teilnehmend',
  'participant.status.completed': 'Beendet',
  'participant.status.disqualified': 'Disqualifiziert',
  'participant.status.withdrawn': 'Zurückgezogen',
  'participant.status.refunded': 'Erstattet',

  'payment.status.pending': 'Zahlung ausstehend',
  'payment.status.confirmed': 'Bezahlt',
  'payment.status.failed': 'Fehlgeschlagen',
  'payment.status.expired': 'Abgelaufen',
  'payment.status.refunded': 'Erstattet',
  'payment.status.cancelled': 'Storniert',

  'payout.status.pending': 'Ausstehend',
  'payout.status.approved': 'Freigegeben',
  'payout.status.processing': 'In Bearbeitung',
  'payout.status.completed': 'Ausgezahlt',
  'payout.status.failed': 'Fehlgeschlagen',
  'payout.status.cancelled': 'Storniert',
  'payout.kind.prize': 'Preis',
  'payout.kind.refund': 'Erstattung',

  'contest.list.title': 'Wettbewerbe',
  'contest.list.subtitle':
    'Durchsuche offene Wettbewerbe, sieh dir den Preistopf an und tritt an.',
  'contest.list.empty': 'Derzeit ist kein Wettbewerb offen. Schau bald wieder vorbei.',
  'contest.list.loadError': 'Wettbewerbe konnten nicht geladen werden.',
  'contest.list.view': 'Wettbewerb ansehen',

  'contest.card.entry': 'Startgebühr',
  'contest.card.free': 'Kostenlos',
  'contest.card.prizePool': 'Preistopf',
  'contest.card.participants': '{count} Teilnehmende',
  'contest.card.startsAt': 'Start {date}',
  'contest.card.endsAt': 'Ende {date}',

  'contest.countdown.opens': 'Anmeldung öffnet in',
  'contest.countdown.closes': 'Anmeldung schließt in',
  'contest.countdown.starts': 'Start in',
  'contest.countdown.ends': 'Ende in',
  'contest.countdown.past': 'Geschlossen',


  'contest.detail.notFound': 'Dieser Wettbewerb wurde nicht gefunden.',
  'contest.detail.loadError': 'Dieser Wettbewerb konnte nicht geladen werden.',
  'contest.detail.about': 'Über diesen Wettbewerb',
  'contest.detail.rules': 'Regeln',
  'contest.detail.prizePool': 'Preistopf',
  'contest.detail.entryFee': 'Startgebühr',
  'contest.detail.asset': 'Wert',
  'contest.detail.paidPlaces': 'Bezahlte Plätze',
  'contest.detail.minParticipants': 'Mindestteilnahme',
  'contest.detail.questions': 'Fragen',
  'contest.detail.secondsPerQuestion': 'Sekunden pro Frage',
  'contest.detail.tieBreak': 'Gleichstandsregel',
  'contest.detail.signInToEnter': 'Anmelden, um teilzunehmen',
  'contest.detail.register': 'Am Wettbewerb teilnehmen',
  'contest.detail.registering': 'Teilnahme läuft…',
  'contest.detail.registered': 'Du bist dabei',
  'contest.detail.start': 'Wettbewerb starten',
  'contest.detail.continue': 'Wettbewerb fortsetzen',
  'contest.detail.viewResults': 'Ergebnisse ansehen',
  'contest.detail.payNow': 'Zahlungsseite öffnen',
  'contest.detail.paymentPending': 'Deine Teilnahme wartet auf die Zahlungsbestätigung.',
  'contest.detail.paymentConfirmed': 'Deine Zahlung ist bestätigt.',
  'contest.detail.paymentRequired': 'Dieser Wettbewerb hat eine Startgebühr.',
  'contest.detail.providerNotConfigured':
    'Online-Zahlung ist noch nicht verfügbar. Wende dich an die Veranstaltung, die deine Teilnahme manuell bestätigen kann.',
  'contest.detail.enterError': 'Die Teilnahme an diesem Wettbewerb war nicht möglich.',
  'contest.detail.cancelled': 'Dieser Wettbewerb wurde abgesagt.',
  'contest.detail.voided': 'Dieser Wettbewerb wurde ungültig und die Startgebühren erstattet.',

  'contest.play.title': 'Wettbewerb läuft',
  'contest.play.questionProgress': 'Frage {current} von {total}',
  'contest.play.timeLeft': 'Restzeit',
  'contest.play.submit': 'Antwort absenden',
  'contest.play.submitting': 'Wird gesendet…',
  'contest.play.submitted': 'Antwort gespeichert',
  'contest.play.answered': 'Beantwortet',
  'contest.play.numericPlaceholder': 'Zahl eingeben, z. B. 12.5',
  'contest.play.multiHint': 'Wähle alle richtigen Optionen. Teilantworten bringen keine Punkte.',
  'contest.play.next': 'Nächste Frage',
  'contest.play.previous': 'Zurück',
  'contest.play.finish': 'Wettbewerb beenden',
  'contest.play.finishing': 'Wird beendet…',
  'contest.play.noAnswers':
    'Du hast noch keine Antwort abgesendet. Beendest du jetzt, ist dein Versuch vorbei.',
  'contest.play.error': 'Diese Antwort konnte nicht gespeichert werden.',
  'contest.play.loadError': 'Der Wettbewerb konnte nicht geladen werden.',
  'contest.play.notStarted': 'Starte den Wettbewerb zuerst auf seiner Seite.',
  'contest.play.finishedTitle': 'Wettbewerb beendet',
  'contest.play.yourScore': 'Deine Punktzahl',
  'contest.play.correctAnswers': 'Richtige Antworten',
  'contest.play.answeredCount': 'Gespeicherte Antworten',
  'contest.play.timeUsed': 'Benötigte Zeit',
  'contest.play.meanwhile':
    'Das Endergebnis erscheint, sobald die Veranstaltung es veröffentlicht.',

  'contest.results.title': 'Ergebnisse',
  'contest.results.notPublished': 'Die Ergebnisse dieses Wettbewerbs sind noch nicht veröffentlicht.',
  'contest.results.empty': 'Keine Ergebnisse vorhanden.',
  'contest.results.loadError': 'Ergebnisse konnten nicht geladen werden.',
  'contest.results.winners': 'Gewinner',
  'contest.results.leaderboard': 'Endstand',
  'contest.results.rank': 'Platz',
  'contest.results.participant': 'Teilnehmende',
  'contest.results.score': 'Punkte',
  'contest.results.correct': 'Richtig',
  'contest.results.time': 'Zeit',
  'contest.results.prize': 'Preis',
  'contest.results.export': 'CSV exportieren',
  'contest.results.review': 'Antworten ansehen',
  'contest.results.correctAnswer': 'Richtige Antwort',
  'contest.results.explanation': 'Erklärung',


  'entries.title': 'Meine Teilnahmen',
  'entries.subtitle': 'Alle Wettbewerbe, an denen du teilgenommen hast, mit Ergebnis und Gewinn.',
  'entries.empty': 'Du hast noch an keinem Wettbewerb teilgenommen.',
  'entries.loadError': 'Deine Teilnahmen konnten nicht geladen werden.',
  'entries.contest': 'Wettbewerb',
  'entries.viewContest': 'Wettbewerb öffnen',
  'entries.noResult': 'Noch kein Ergebnis',
  'entries.myPayouts': 'Meine Auszahlungen',
  'entries.payoutsEmpty': 'Du hast noch keine Auszahlungen.',

  'admin.queue.title': 'Betrieb',
  'admin.queue.description': 'Wettbewerbe, Startgebühren und offene Beträge.',
  'admin.queue.payments': 'Zahlungen mit Handlungsbedarf',
  'admin.queue.payouts': 'Auszahlungen mit Handlungsbedarf',
  'admin.queue.reconciliation': 'Zur Abstimmung markiert',

  'admin.contests.title': 'Wettbewerbe',
  'admin.contests.subtitle':
    'Wettbewerbe anlegen, Fragen verfassen und den Lebenszyklus steuern.',
  'admin.contests.create': 'Neuer Wettbewerb',
  'admin.contests.empty': 'Noch keine Wettbewerbe.',
  'admin.contests.loadError': 'Wettbewerbe konnten nicht geladen werden.',
  'admin.contests.formHeading': 'Wettbewerb anlegen',
  'admin.contests.formHint':
    'Startgebühr, Wert und Zeiten sind nach dem Entwurf unveränderlich – prüfe sie sorgfältig.',
  'admin.contests.field.title': 'Titel',
  'admin.contests.field.summary': 'Kurzbeschreibung',
  'admin.contests.field.description': 'Beschreibung',
  'admin.contests.field.rules': 'Regeln',
  'admin.contests.field.rail': 'Zahlungsweg',
  'admin.contests.field.asset': 'Wert',
  'admin.contests.field.entryFee': 'Startgebühr (z. B. 10.00)',
  'admin.contests.field.sponsor': 'Sponsoring (optional)',
  'admin.contests.field.feeBps': 'Plattformgebühr (Basispunkte)',
  'admin.contests.field.minParticipants': 'Mindestteilnahme',
  'admin.contests.field.maxParticipants': 'Höchstteilnahme',
  'admin.contests.field.paidPlaces': 'Bezahlte Plätze',
  'admin.contests.field.regOpens': 'Anmeldung öffnet',
  'admin.contests.field.regCloses': 'Anmeldung schließt',
  'admin.contests.field.startsAt': 'Wettbewerb beginnt',
  'admin.contests.field.endsAt': 'Wettbewerb endet',
  'admin.contests.field.perQuestionSeconds': 'Sekunden pro Frage (0 = gesamtes Fenster)',
  'admin.contests.field.tieBreak': 'Gleichstandsregel',
  'admin.contests.tieBreak.total_time': 'Gesamte Antwortzeit',
  'admin.contests.tieBreak.earliest_completion': 'Frühestes Beenden',
  'admin.contests.created': 'Wettbewerb als Entwurf angelegt.',
  'admin.contests.prizePoolLabel': 'Preispool',
  'admin.contests.platformFeeLabel': 'Plattformgebühr',
  'admin.contests.noPublicPage': 'Keine öffentliche Seite',
  'admin.contests.questions': 'Fragen',
  'admin.contests.noQuestions': 'Noch keine Fragen.',
  'admin.contests.addQuestion': 'Frage hinzufügen',
  'admin.contests.questionKind': 'Fragetyp',
  'admin.contests.kind.single_choice': 'Eine richtige Antwort',
  'admin.contests.kind.multi_choice': 'Mehrere richtige Antworten',
  'admin.contests.kind.true_false': 'Wahr oder falsch',
  'admin.contests.kind.numeric': 'Numerische Antwort',
  'admin.contests.prompt': 'Frage',
  'admin.contests.points': 'Punkte',
  'admin.contests.options': 'Optionen',
  'admin.contests.optionLabel': 'Option {n}',
  'admin.contests.correct': 'Richtig',
  'admin.contests.numericAnswer': 'Richtige Zahl',
  'admin.contests.numericTolerance': 'Zulässige Toleranz',
  'admin.contests.hintLabel': 'Hinweis (optional)',
  'admin.contests.explanationLabel': 'Erklärung (wird mit den Ergebnissen gezeigt)',
  'admin.contests.saveQuestion': 'Frage speichern',
  'admin.contests.deleteQuestion': 'Frage löschen',
  'admin.contests.answerKey': 'Lösungsschlüssel',
  'admin.contests.unkeyed':
    'Bei einigen Fragen fehlt die richtige Antwort. Korrigiere das vor der Planung.',
  'admin.contests.transitions': 'Lebenszyklus',
  'admin.contests.action.schedule': 'Wettbewerb planen',
  'admin.contests.action.finalize': 'Ergebnisse feststellen',
  'admin.contests.action.publish': 'Ergebnisse veröffentlichen',
  'admin.contests.action.cancel': 'Wettbewerb absagen',
  'admin.contests.action.void': 'Ungültig erklären und erstatten',
  'admin.contests.cancelReason': 'Begründung (wird protokolliert)',
  'admin.contests.participants': 'Teilnehmende',
  'admin.contests.disqualify': 'Disqualifizieren',
  'admin.contests.disqualifyReason': 'Grund der Disqualifikation',
  'admin.contests.payments': 'Startgebühren',
  'admin.contests.payouts': 'Auszahlungen',
  'admin.contests.ledger': 'Kassenbuch',
  'admin.contests.transitionDone': 'Erledigt.',


  'admin.payments.title': 'Zahlungen und Auszahlungen',
  'admin.payments.subtitle':
    'Teilnahmen prüfen, Zahlungen verbuchen und Preise sowie Erstattungen auszahlen.',
  'admin.payments.loadError': 'Zahlungen konnten nicht geladen werden.',
  'admin.payments.entry': 'Teilnahme',
  'admin.payments.provider': 'Anbieter',
  'admin.payments.reference': 'Referenz',
  'admin.payments.settle': 'Zahlungseingang erfassen',
  'admin.payments.settleAmount': 'Erhaltener Betrag',
  'admin.payments.settleNote': 'Notiz',
  'admin.payments.settleDone': 'Zahlungseingang erfasst.',
  'admin.payments.resolve': 'Abstimmungsmarkierung entfernen',
  'admin.payments.resolveNote': 'Was hast du festgestellt?',
  'admin.payments.expire': 'Rechnung verfallen lassen',
  'admin.payments.flagged': 'Zur Abstimmung markiert',
  'admin.payouts.title': 'Auszahlungen',
  'admin.payouts.empty': 'Noch keine Auszahlungen.',
  'admin.payouts.approve': 'Freigeben',
  'admin.payouts.process': 'Als in Bearbeitung markieren',
  'admin.payouts.complete': 'Als ausgezahlt markieren',
  'admin.payouts.fail': 'Als fehlgeschlagen markieren',
  'admin.payouts.failReason': 'Warum ist es fehlgeschlagen?',
  'admin.payouts.cancel': 'Auszahlung stornieren',
  'admin.payouts.createRefunds': 'Alle bestätigten Teilnahmen erstatten',
  'admin.ledger.title': 'Kassenbuch',
  'admin.ledger.balances': 'Salden je Zahlungsweg',
  'admin.ledger.note':
    'Salden gelten je Zahlungsweg und je Wert; sie werden nie über Zahlungswege hinweg addiert.',
  'admin.ledger.entryType': 'Art',
  'admin.ledger.direction': 'Richtung',
  'admin.ledger.credits': 'Eingang',
  'admin.ledger.debits': 'Ausgang',
  'admin.ledger.net': 'Saldo',

  'api.contestNotFound': 'Dieser Wettbewerb existiert nicht.',
  'api.registrationClosed': 'Die Anmeldung für diesen Wettbewerb ist geschlossen.',
  'api.contestFull': 'Dieser Wettbewerb ist voll.',
  'api.notEnrolled': 'Du bist für diesen Wettbewerb nicht angemeldet.',
  'api.notActive': 'Du nimmst derzeit nicht an diesem Wettbewerb teil.',
  'api.entryNotConfirmed': 'Deine Teilnahme ist noch nicht bestätigt.',
  'api.contestNotLive': 'Dieser Wettbewerb ist nicht zur Teilnahme geöffnet.',
  'api.alreadyAnswered': 'Du hast diese Frage bereits beantwortet.',
  'api.submissionRejected':
    'Diese Antwort wurde nicht angenommen – das Wettbewerbsfenster ist geschlossen.',
  'api.answerInvalid': 'Diese Antwort ist für diese Frage ungültig.',
  'api.resultsNotPublished': 'Die Ergebnisse sind noch nicht veröffentlicht.',
  'api.rateLimited': 'Zu viele Anfragen. Bitte warte kurz und versuche es erneut.',
  'api.paymentNotFound': 'Diese Zahlung existiert nicht.',
  'api.payoutNotFound': 'Diese Auszahlung existiert nicht.',
  'api.notFinalized': 'Stelle die Ergebnisse fest, bevor du sie veröffentlichst.',
  'api.reasonRequired': 'Eine Begründung ist erforderlich.',
  'api.idempotencyKeyReused': 'Diese Anfrage wurde bereits für eine andere Antwort verwendet.',
  'api.contestNotEditable': 'Ein Wettbewerb kann nur im Entwurf bearbeitet werden.',
  'api.contentLocked':
    'Der Inhalt des Wettbewerbs kann nach dem Start nicht mehr geändert werden.',
  'api.invalidAmount': 'Gib einen gültigen Betrag ein, z. B. 10.00',
  'api.assetRailMismatch': 'Dieser Wert gehört nicht zum gewählten Zahlungsweg.',
  'api.unknownAsset': 'Dieser Wert wird nicht unterstützt.',
  'api.invalidWindow': 'Anmelde- und Wettbewerbszeiten sind nicht in gültiger Reihenfolge.',
  'api.contestHasNoQuestions': 'Füge mindestens eine Frage hinzu, bevor du planst.',
  'api.questionWithoutAnswerKey': 'Jede Frage braucht vor der Planung eine richtige Antwort.',
  'api.answerKeyRequired': 'Lege die richtige Antwort für diese Frage fest.',
  'api.optionsRequired': 'Eine Auswahlfrage braucht mindestens zwei Optionen.',
  'api.transitionContended': 'Der Wettbewerb hat sich währenddessen geändert. Neu laden und erneut versuchen.',
  'api.invalidTransition': 'Diese Lebenszyklusänderung ist für diesen Wettbewerb nicht erlaubt.',
  'api.notFlagged': 'Diese Zahlung wartet nicht auf eine Abstimmung.',


  'pay.title': 'Mit USDT bezahlen',
  'pay.notIssued': 'Für diese Teilnahme ist keine Zahlung erforderlich.',
  'pay.amount': 'Zu sendender Betrag',
  'pay.network': 'Netzwerk',
  'pay.address': 'Einzahlungsadresse',
  'pay.copy': 'Adresse kopieren',
  'pay.copied': 'Adresse kopiert',
  'pay.openInWallet': 'In Wallet öffnen',
  'pay.received': 'Erhalten',
  'pay.confirmations': 'Bestätigungen',
  'pay.txHash': 'Transaktion',
  'pay.viewOnExplorer': 'Im Block-Explorer ansehen',
  'pay.expires': 'Bezahlen bis',
  'pay.checkNow': 'Ich habe bezahlt – jetzt prüfen',
  'pay.checking': 'Blockchain wird geprüft…',
  'pay.autoCheck': 'Wir prüfen die Blockchain auch automatisch.',
  'pay.qrLabel': 'QR-Code der Einzahlungsadresse',
  'pay.scanHint': 'Mit der Wallet-App scannen oder die Adresse kopieren.',
  'pay.awaitingHint':
    'Sende genau diesen USDT-Betrag auf diesem Netzwerk an die unten stehende Adresse. Die Adresse gilt nur für diese Teilnahme.',
  'pay.detectedHint': 'Wir sehen deine Überweisung auf der Blockchain.',
  'pay.confirmingHint':
    'Deine Überweisung ist auf der Blockchain und wartet auf Bestätigungen. Deine Teilnahme wird automatisch aktiviert.',
  'pay.confirmedHint': 'Zahlung bestätigt. Du nimmst an diesem Wettbewerb teil.',
  'pay.overpaidHint':
    'Zahlung bestätigt. Du hast mehr als die Startgebühr gesendet; der Überschuss wird zur Prüfung erfasst.',
  'pay.underpaidHint':
    'Der erhaltene Betrag liegt unter der Startgebühr. Sende den Rest an dieselbe Adresse oder kontaktiere den Support.',
  'pay.expiredHint':
    'Diese Rechnung ist abgelaufen. Starte die Teilnahme erneut, um eine neue Adresse zu erhalten.',
  'pay.invalidHint':
    'Wir haben eine nicht akzeptierte Überweisung für diese Teilnahme erhalten (falscher Token oder falsches Netzwerk). Kontaktiere den Support.',
  'pay.failedHint':
    'Diese Zahlung konnte dieser Teilnahme nicht zugeordnet werden. Kontaktiere den Support.',
  'pay.status.awaiting_payment': 'Zahlung ausstehend',
  'pay.status.detected': 'Erkannt',
  'pay.status.confirming': 'Wird bestätigt',
  'pay.status.confirmed': 'Bestätigt',
  'pay.status.underpaid': 'Unterbezahlt',
  'pay.status.overpaid': 'Überbezahlt',
  'pay.status.expired': 'Abgelaufen',
  'pay.status.invalid': 'Nicht akzeptiert',
  'pay.status.failed': 'Fehlgeschlagen',

  'login.google': 'Mit Google fortfahren',
  'login.or': 'oder',
  'login.staffNote':
    'Die Anmeldung mit Passwort bleibt für Mitarbeitende und bestehende Konten verfügbar.',
  'login.googleError.cancelled':
    'Die Anmeldung mit Google wurde abgebrochen. Du kannst es jederzeit erneut versuchen.',
  'login.googleError.unavailable':
    'Die Anmeldung mit Google ist in dieser Bereitstellung nicht verfügbar. Verwende eine andere Methode oder kontaktiere den Support.',
  'login.googleError.accountConflict':
    'Wir konnten dich mit diesem Google-Konto nicht anmelden, da es bereits mit einem anderen ITA6-Konto verbunden ist. Kontaktiere den Support.',
  'login.googleError.accountInactive': 'Dieses ITA6-Konto ist nicht aktiv. Kontaktiere den Support.',
  'login.googleError.failed': 'Die Anmeldung mit Google wurde nicht abgeschlossen. Bitte erneut versuchen.',
  'register.google': 'Mit Google registrieren',
  'nav.adminCrypto': 'Krypto',
  'admin.crypto.title': 'Krypto-Konsole',
  'admin.crypto.subtitle':
    'USDT on-chain: der Pool der Einzahlungsadressen, Rechnungen, beobachtete Transfers, Auszahlungen und Abgleich.',
  'admin.crypto.loadError': 'Die Krypto-Konsole konnte nicht geladen werden.',
  'admin.crypto.rails': 'Zahlungskanäle',
  'admin.crypto.railsDisabled': 'deaktiviert',
  'admin.crypto.networks': 'Netzwerke und Einzahlungsadressen',
  'admin.crypto.available': 'verfügbar',
  'admin.crypto.unsupported': 'Nicht unterstützt',
  'admin.crypto.pool': 'Pool der Einzahlungsadressen',
  'admin.crypto.poolHint':
    'Jede Teilnahme verbraucht eine Einzahlungsadresse. Ist der Pool leer, werden Teilnahmen abgelehnt, statt eine Adresse zu vergeben, die nicht zugeordnet werden kann — importiere rechtzeitig mehr.',
  'admin.crypto.importNetwork': 'Netzwerk',
  'admin.crypto.importAsset': 'Token',
  'admin.crypto.poolFilter': 'Anzeigen',
  'admin.crypto.poolStatus.available': 'Verfügbar',
  'admin.crypto.poolStatus.assigned': 'Zugewiesen',
  'admin.crypto.poolStatus.retired': 'Ausgemustert',
  'admin.crypto.import': 'Öffentliche Adressen importieren',
  'admin.crypto.importPlaceholder': 'Eine Adresse pro Zeile',
  'admin.crypto.importHint':
    'Nur ÖFFENTLICHE Adressen — niemals ein privater Schlüssel. Jede Zeile wird gegen das echte Adressformat der Chain geprüft; ein fehlerhafter Eintrag lehnt den gesamten Import ab.',
  'admin.crypto.importButton': 'Adressen importieren',
  'admin.crypto.importEmpty': 'Füge mindestens eine Adresse ein.',
  'admin.crypto.imported': '{count} Adresse(n) importiert. {available} jetzt verfügbar.',
  'admin.crypto.address': 'Adresse',
  'admin.crypto.network': 'Netzwerk',
  'admin.crypto.status': 'Status',
  'admin.crypto.assignedTo': 'Zugewiesen an',
  'admin.crypto.empty': 'Nichts anzuzeigen.',
  'admin.crypto.runMonitor': 'Chain-Überwachung starten',
  'admin.crypto.monitorDone': 'Überwachung beendet: {examined} geprüft, {settled} abgerechnet.',
  'admin.crypto.signer': 'Signatur der Auszahlungen',
  'admin.crypto.signerReady': 'Signierdienst konfiguriert',
  'admin.crypto.signerMissing':
    'Kein Signierdienst konfiguriert — Auszahlungen können nicht automatisch gesendet werden. Sie können weiterhin manuell gesendet und der Hash erfasst werden.',
  'admin.crypto.payoutWallet': 'Auszahlungs-Wallet',
  'admin.crypto.payoutWalletMissing': 'Nicht konfiguriert',
  'admin.crypto.emulator': 'Chain-Emulator',
  'admin.crypto.emulatorOn': 'Aktiviert — nur Probe, niemals Produktion',
  'admin.crypto.emulatorOff': 'Deaktiviert',
  'admin.crypto.emulatorQueued': '{count} wartende Beobachtung(en)',
  'admin.crypto.stuck': 'Zahlungen, die Aufmerksamkeit brauchen',
  'admin.crypto.recheck': 'Jetzt prüfen',
  'admin.crypto.recheckDone': 'Erneut gegen die Chain geprüft.',
  'admin.crypto.invoices': 'Krypto-Rechnungen',
  'admin.crypto.participant': 'Teilnehmer',
  'admin.crypto.expected': 'Erwartet',
  'admin.crypto.received': 'Erhalten',
  'admin.crypto.confirmations': 'Bestätigungen',
  'admin.crypto.depositAddress': 'Einzahlungsadresse',
  'admin.crypto.txHash': 'Transaktion',
  'admin.crypto.amount': 'Betrag',
  'admin.crypto.classification': 'Eingestuft als',
  'admin.crypto.from': 'Von',
  'admin.crypto.transfers': 'Beobachtete On-Chain-Transfers',
  'admin.crypto.reconciliation': 'Abgleich',
  'admin.crypto.reconciliationHint':
    'Was wir erfasst haben, gegenüber dem, was die Chain sagt. Eine Abweichung wird gemeldet und niemals stillschweigend korrigiert.',
  'admin.crypto.applicationIn': 'Erfasst eingehend',
  'admin.crypto.applicationOut': 'Erfasst ausgehend',
  'admin.crypto.observed': 'On-chain beobachtet',
  'admin.crypto.discrepancy': 'Abweichung',
  'admin.crypto.notReadable': 'konnte nicht aus der Chain gelesen werden',
  'admin.crypto.unmatched': 'Nicht zugeordnete Transfers',
  'admin.crypto.payoutsHint': 'genehmige, signiere und begleiche Auszahlungen dort.',
  'admin.crypto.mode': 'Signierung',
  'admin.crypto.mode.inWorker': 'im Worker',
  'admin.crypto.mode.externalSigner': 'externer Signierdienst',
  'admin.crypto.mode.manualOnly': 'nur manuell',
  'legal.privacy': 'Datenschutzerklärung',
  'legal.terms': 'Allgemeine Geschäftsbedingungen',
  'legal.lastUpdated': 'Zuletzt aktualisiert am {date}',
  'legal.authoritativeNote':
    'Dieses Dokument wird in mehreren Sprachen bereitgestellt. Bei Abweichungen von der englischen Fassung ist die englische Fassung maßgeblich.',

};
